"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var teamMateRule_exports = {};
__export(teamMateRule_exports, {
  teamMateRule: () => teamMateRule
});
module.exports = __toCommonJS(teamMateRule_exports);
var import_permission = require("@cartographerio/permission");
var import_topo_core = require("@cartographerio/topo-core");
var import_types = require("@cartographerio/types");
var import_helpers = require("../helpers.js");
const teamMateRule = ({ identity, graph, project }) => {
  const relevantTeams = graph.findTeamsByProjectId(project.id).filter((team) => identity.roles.some((role) => (0, import_types.roleGte)(role, (0, import_types.teamMemberRole)(team.id))));
  const ruleApplies = relevantTeams.length > 0 && !(0, import_permission.permissionCheckPasses)(
    import_permission.checks.survey.createWithTeam(project, null),
    {
      id: identity.userId,
      roles: identity.roles,
      qualificationRoles: identity.qualificationRoles
    },
    graph
  );
  return (survey) => {
    const { surveyor } = survey;
    if (!ruleApplies) {
      return [];
    }
    const surveyorUser = (0, import_helpers.getSurveyorUser)(graph, surveyor);
    if (surveyorUser == null) {
      return [];
    }
    const passes = surveyorUser.roles.some(
      (role) => relevantTeams.some((team) => (0, import_types.roleGte)(role, (0, import_types.teamMemberRole)(team.id)))
    );
    if (passes) {
      return [];
    }
    return [(0, import_topo_core.errorMessage)("The selected user is not a member of your team(s)")];
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  teamMateRule
});
//# sourceMappingURL=teamMateRule.js.map
